<div
  class="login-page flex align-items-start sm:align-items-center justify-content-center min-h-screen surface-ground p-3 sm:p-4"
>
  <p-card class="w-full max-w-full sm:max-w-26rem login-card-mobile">
    <ng-template #header>
      <div class="flex flex-column align-items-center gap-2 text-center pt-4 px-4 pb-0">
        <img
          class="login-logo"
          [src]="theme.oscuro() ? 'assets/marca/mayorap-logo-blanco.png' : 'assets/marca/mayorap-logo-negro.png'"
          alt="Mayorap"
        />
        <p class="m-0 text-color-secondary text-sm">Iniciá sesión para continuar</p>
      </div>
    </ng-template>

    @if (sesionActiva) {
      <div class="flex flex-column gap-2 px-4 pb-2">
        <p class="m-0 text-sm text-color-secondary">Ya hay una sesión en este navegador.</p>
        <p-button
          type="button"
          label="Entrar"
          icon="pi pi-arrow-right"
          [outlined]="true"
          styleClass="w-full"
          (onClick)="entrarConSesion()"
        />
      </div>
    }

    <form class="flex flex-column gap-4 px-4 pb-2" [formGroup]="loginForm" (ngSubmit)="onSubmit()">
      <div class="flex flex-column gap-1">
        <label class="text-sm font-medium" for="email">Correo electrónico</label>
        <input
          pInputText
          id="email"
          type="email"
          formControlName="mailAccess"
          placeholder="nombre@ejemplo.com"
          autocomplete="email"
          class="w-full"
          [class.ng-invalid]="loginForm.controls.mailAccess.invalid && loginForm.controls.mailAccess.touched"
          [class.ng-dirty]="loginForm.controls.mailAccess.touched"
        />
        @if (loginForm.controls.mailAccess.invalid && loginForm.controls.mailAccess.touched) {
          <small class="text-red-500 text-xs">
            @if (loginForm.controls.mailAccess.hasError('required')) {
              El correo es obligatorio.
            } @else {
              Ingresá un correo válido.
            }
          </small>
        }
      </div>

      <div class="flex flex-column gap-1">
        <label class="text-sm font-medium" for="password">Contraseña</label>
        <input
          pInputText
          id="password"
          type="password"
          formControlName="password"
          placeholder="Tu contraseña"
          autocomplete="current-password"
          autocapitalize="none"
          autocorrect="off"
          spellcheck="false"
          class="w-full"
        />
      </div>

      <p-button
        type="submit"
        label="Ingresar"
        icon="pi pi-sign-in"
        [loading]="loading"
        styleClass="mt-1 w-full"
      />
    </form>
    <p class="m-0 px-4 pb-4 text-center">
      <a routerLink="/" class="text-sm text-primary no-underline">Volver al inicio</a>
    </p>
  </p-card>

  <p-dialog
    header="Definí tu contraseña"
    [visible]="definiendoPassword()"
    [modal]="true"
    [closable]="false"
    [closeOnEscape]="false"
    [draggable]="false"
    [style]="{ width: 'min(24rem, 92vw)' }"
  >
    <p class="mt-0 text-color-secondary">
      Entraste sin contraseña. Cargala y confirmala para que quede registrada.
    </p>
    <form class="flex flex-column gap-3" [formGroup]="passwordForm" (ngSubmit)="guardarPassword()">
      <div class="flex flex-column gap-1">
        <label class="text-sm font-medium" for="nueva-password">Contraseña</label>
        <input
          pInputText
          id="nueva-password"
          type="password"
          formControlName="password"
          autocomplete="new-password"
          autocapitalize="none"
          autocorrect="off"
          spellcheck="false"
          class="w-full"
        />
        @if (passwordForm.controls.password.invalid && passwordForm.controls.password.touched) {
          <small class="text-red-500 text-xs">Mínimo 6 caracteres.</small>
        }
      </div>
      <div class="flex flex-column gap-1">
        <label class="text-sm font-medium" for="confirmar-password">Confirmar contraseña</label>
        <input
          pInputText
          id="confirmar-password"
          type="password"
          formControlName="confirmacion"
          autocomplete="new-password"
          autocapitalize="none"
          autocorrect="off"
          spellcheck="false"
          class="w-full"
        />
        @if (passwordForm.hasError('mismatch') && passwordForm.controls.confirmacion.touched) {
          <small class="text-red-500 text-xs">Las contraseñas no coinciden.</small>
        }
      </div>
      <div class="flex justify-content-end gap-2 pt-2">
        <p-button
          type="button"
          label="Cancelar"
          severity="secondary"
          [outlined]="true"
          (onClick)="cancelarPassword()"
        />
        <p-button type="submit" label="Guardar" [loading]="guardandoPassword()" />
      </div>
    </form>
  </p-dialog>
</div>
